export default "__VITE_ASSET__Xu1z6JjK__"